import { forwardRef } from 'react';
import style from './style.module.scss';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	type: string;
	name: string;
	label?: string;
	placeholder?: string;
	error?: string;
	displayError?: boolean;
	allowDecimals?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
	({ type, name, label, placeholder, error, className, displayError = false, allowDecimals = true, ...rest }, ref) => {
		const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
			if (type === 'number' && !allowDecimals) {
				if (e.key === '.' || e.key === ',') e.preventDefault();
			}

			if (rest.onKeyUp) rest.onKeyUp(e);
		};

		return (
			<div className={className}>
				{label && (
					<label htmlFor={name} className={style.label}>
						{label}
					</label>
				)}
				<input
					ref={ref}
					className={[style.input, error ? style['input-error'] : ''].join(' ')}
					type={type ?? 'text'}
					placeholder={placeholder ?? ''}
					name={name}
					autoComplete='off'
					spellCheck='false'
					autoCorrect='off'
					autoCapitalize='off'
					data-form-type='other'
					{...rest}
					onKeyUp={handleKeyUp}
					aria-invalid={!!error}
					aria-describedby={error ? `${name}-error` : undefined}
				/>
				{error && displayError && (
					<span id={`${name}-error`} className={style['error-message']} role='alert'>
						{error}
					</span>
				)}
			</div>
		);
	}
);

export default FormInput;
